import { request } from '@/api/request'

export const getUserSupportInfo = async (userId: string) => {
  const { data } = await request.get(`/webapi/nimda/user/support/${userId}`)

  return data.value
}

export const checkUserIsSupport = async () => {
  const { data } = await request.get(`/webapi/nimda/auth/support`)

  return data.value
}